import { useLayoutEffect, useRef, useState } from 'react';

/** Measure the whole dock, including reply/upload UI, without observing each row. */
export function useComposerInset(enabled: boolean, channelId: string | null) {
  const dockRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => {
    const dock = dockRef.current;
    if (!enabled || !dock) return;
    const measure = () => {
      const next = Math.ceil(dock.getBoundingClientRect().height);
      setHeight((previous) => previous === next ? previous : next);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(dock);
    return () => observer.disconnect();
  }, [enabled, channelId]);
  return { dockRef, bottomInset: enabled ? height : 0 };
}
